import { forwardRef, useImperativeHandle, useRef } from "react";
import { useSelector } from "react-redux";
import { DragProvider } from "./contexts/DragContext";
import { MatchProvider } from "./contexts/MatchContext";
import { Match } from "./components/Match";

const Game = forwardRef(function Game({ onAnswer }, ref) {
  const matchRef = useRef(null);
  const questions = useSelector((state) => state.game.questions);
  const currentQuestion = useSelector(
    (state) => state.game.questions[state.game.currentIndex]
  );

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      await matchRef.current?.animateEntry();
    },
    animateExit: async () => {
      await matchRef.current?.animateExit();
    },
    getUserAnswer: () => {
      const currentScreenId = currentQuestion.screenId;
      const totalScreens = questions[questions.length - 1].screenId + 1;
      const isFinalScreen = currentScreenId + 1 === totalScreens;

      if (isFinalScreen) {
        return { data: "", isCorrect: false, points: 0, shouldFinish: true };
      }

      const nextScreenFirstQuestion = questions.find(
        (q) => q.screenId === currentScreenId + 1
      );

      return {
        data: "",
        isCorrect: false,
        points: 0,
        nextQuestionIndex: nextScreenFirstQuestion?.id ?? 0,
      };
    },
  }));

  return (
    <MatchProvider>
      <DragProvider>
        <Match
          onAnswer={onAnswer}
          key={currentQuestion.screenId}
          currentQuestion={currentQuestion}
          ref={matchRef}
        />
      </DragProvider>
    </MatchProvider>
  );
});

export default Game;
